import { EntityAlert } from "../../entity/EntityAlert";

export class DtoAlertsPostRes extends EntityAlert {}
